import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import useSubscriptionStatus from '../hooks/useSubscriptionStatus';

const SubscriptionContext = createContext();

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider = ({ children }) => {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const { user } = useAuth();
  const { hasActiveSubscription, isChecking, checkSubscriptionStatus } = useSubscriptionStatus();

  // Reset modal for non-vendors
  useEffect(() => {
    if (user?.user_type !== 'vendor') {
      setShowSubscriptionModal(false);
    }
  }, [user?.user_type]);

  // Hide modal when user has active subscription
  useEffect(() => {
    if (hasActiveSubscription === true) {
      setShowSubscriptionModal(false);
    }
  }, [hasActiveSubscription]);

  // We no longer auto-prompt subscription for vendors.
  // Vendors can proceed with verification and dashboard onboarding first.

  const hideSubscriptionModal = () => {
    setShowSubscriptionModal(false);
  };

  const openSubscriptionModal = () => {
    setShowSubscriptionModal(true);
  };

  const value = {
    hasActiveSubscription,
    showSubscriptionModal: openSubscriptionModal,
    hideSubscriptionModal,
    checkSubscriptionStatus,
    isChecking,
    showSubscriptionModalState: showSubscriptionModal
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};
